
import { Component, Prop, Vue } from 'vue-property-decorator';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  Heading,
  Row,
  BaseText,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { TradeInstrumentPositionPrice } from '@/modules/trade/types/instrument';

import { getInstrumentDividendTotalReceived } from '@/modules/trade/services/instruments';

import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

import { Feature } from '@/modules/common/components/Feature';
import { useDashStore } from '@/modules/common/store/DashModule';

@Component({
  components: {
    Heading,
    Row,
    BaseText,
    SkeletonLoader,
    Feature
  }
})
export default class InstrumentPositions extends Vue {
  private readonly dashModule = useDashStore();

  @Prop({ type: Object, required: true })
  readonly position!: TradeInstrumentPositionPrice;

  readonly showMoney: boolean = this.dashModule.showMoney;

  readonly NebraskaColors = NebraskaColors;

  public dividendTotalReceived!: string;
  public isLoading = true;

  public get FeatureFlags() {
    return FeatureFlags;
  }

  get isFinOneIntegrationWithTradeV0Enabled() {
    return FeatureFlagsModule.isEnabled(
      this.FeatureFlags.ENABLE_FIN_ONE_INTEGRATION_WITH_TRADE_V0
    );
  }

  private get isFeatureFlagV2PositionsWithBffEnabled() {
    return FeatureFlagsModule.isEnabled(
      this.FeatureFlags.TRADE_EARNINGS_ACTIVE_PAGE
    );
  }

  mounted() {
    this.loadDividendTotalReceived();
  }

  private async loadDividendTotalReceived() {
    if (!this.isFeatureFlagV2PositionsWithBffEnabled) return;

    try {
      const { dividendTotalReceived } =
        await getInstrumentDividendTotalReceived(this.position.symbol);

      this.dividendTotalReceived = dividendTotalReceived.formatted;
    } catch (error) {
      this.dividendTotalReceived = 'R$ -';
    } finally {
      this.isLoading = false;
    }
  }

  get currentValue() {
    return this.position.currentValue?.formatted;
  }

  get avgPrice() {
    return this.position.avgPrice?.formatted;
  }

  get profitPercentageValue() {
    if (this.isFeatureFlagV2PositionsWithBffEnabled) {
      return this.position.profitPercentage?.value;
    }
    // @ts-ignore
    return this.position.totalEarnings?.value;
  }

  get profitPercentageFormatted() {
    if (this.isFeatureFlagV2PositionsWithBffEnabled) {
      return this.position.profitPercentage?.formatted;
    }
    // @ts-ignore
    return this.position.totalEarnings?.formatted;
  }

  get totalProfitabilityFormatted() {
    return this.position?.profitPrice?.formatted;
  }
}
